export var REPORT_CONTROL_TYPE_DATE = 'singleValueDate';
export var REPORT_CONTROL_TYPE_DATETIME = 'singleValueDatetime';
export var REPORT_CONTROL_TYPE_NUMBER = 'singleValueNumber';
export var REPORT_CONTROL_TYPE_SINGLE_SELECT = 'singleSelect';
export var REPORT_CONTROL_TYPE_MULTI_SELECT = 'multiSelect';
export var REPORT_CONTROL_TYPE_TEXT = 'singleValueText';
export var DATE_FORMAT = 'DD-MMM-YYYY';
export var DATE_TIME_FORMAT = 'DD-MMM-YYYY HH:mm';

export var USER_TRIAL_ACCESS_PENDING = 'PENDING';
export var USER_TRIAL_ACCESS_DENIED = 'DENIED';
var MANUAL = 'MANUAL';
var MANUAL_BLINDING = 'MANUAL_BLINDING';
var AUTOMATIC_BLINDING = 'AUTOMATIC_BLINDING';

export var profileCreationMethods = {
  MANUAL: MANUAL,
  MANUAL_BLINDING: MANUAL_BLINDING,
  AUTOMATIC_BLINDING: AUTOMATIC_BLINDING
};